/* eslint-disable */

/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Drivers Portal (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { CCard, CCardBod, CCardBody, CCardHeader } from '@coreui/react';
import { Button, Form, Input, InputNumber, Modal, Pagination, Select, Spin, Switch, Table, Upload, message, notification } from 'antd';
import React, { useEffect, useState } from 'react';

import Jwt_decrypt from "common/Jwt_decrypt";
import axios from "common/axios_call";
import { _get_profile } from "common/axios_services";
import { Link, useNavigate } from "react-router-dom";

function SubCategories() {
    const navigate = useNavigate()
    const [form] = Form.useForm();
    const [page, setPage] = useState(1);
    const [total_subcategories, setTotal_subcategories] = useState(0);
    const [page_size, setPage_size] = useState(10);
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    const [allProducts, setAllProducts] = useState('sub-category');
    const [imageUrl, setImageUrl] = useState(null);
    const [imageToSend, setImageToSend] = useState(null);
    const [loading, setLoading] = useState(false);
    const [categoryBox, setCategoryBox] = useState([]);
    const [cat, setCat] = useState([]);
    const [categoryErrorMessage, setCategoryErrorMessage] = useState('');
    const [fetchingData, setFetchingData] = useState(true);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedSubCategoryId, setSelectedSubCategoryId] = useState("");
    const [updateCount, setUpdateCount] = useState(0);
    const [addSubCategories, setAddSubCategories] = useState(false);
    const [deleteSubCategories, setDeleteSubCategories] = useState(false);

    const jwt = localStorage.konnect_admin_token;

    const openNotificationWithIcon = (type, message) => {
        notification[type]({
            message: '',
            placement: 'bottomRight',
            description:
                message,
        });
    };

    const { TextArea } = Input;

    if (!jwt) {
        openNotificationWithIcon('error', 'Unauthorized')
        return navigate('/')
    }

    const token = Jwt_decrypt({ token: localStorage.konnect_admin_token });

    const fetchUser = async () => {
        const user_profile = await _get_profile()
        if (user_profile.data.status == "success") {
            if (user_profile.data.data.role.role_access.includes("addSubCategory")) {
                setAddSubCategories(true)
            } else {
                setAddSubCategories(false)
            }
            if (user_profile.data.data.role.role_access.includes("deleteSubCategory")) {
                setDeleteSubCategories(true)
            } else {
                setDeleteSubCategories(false)
            }
        } else {
            setDeleteSubCategories(false)
            setAddSubCategories(false)
        }
    }
    useEffect(() => {
        axios(`/sub-category?page=${page}&per_page=${page_size}`, { headers: { Authorization: `Bearer ${token}` } })
            .then(res => {
                setFetchingData(false);
                let subCategoryData = [];
                res.data.data.forEach(freshData => {
                    let storeData = {
                        subCategoryData: freshData,
                    }
                    subCategoryData.push(storeData);
                })
                setCategoryBox(subCategoryData);
                setTotal_subcategories(res.data.meta.total)
            })
            .catch(err => {
                setFetchingData(false);
                openNotificationWithIcon('error', err.response.data.message);
            })
        axios(`/category?page=${1}&per_page=${50}`, { headers: { Authorization: `Bearer ${token}` } })
            .then(res => {
                setFetchingData(false);
                let cat = [];
                res.data.data.forEach(freshData => {
                    let storeData = {
                        cat: freshData,
                    }
                    cat.push(storeData);
                })
                setCat(cat);
            })
            .catch(err => {
                setFetchingData(false);
                openNotificationWithIcon('error', err.response.data.message);
            })
        fetchUser()
    }, [page, page_size, updateCount])

    // const { handleSubmit, control } = useForm({});

    // Functions to handle
    const addSubCategory = (values) => {
        axios.post('/sub-category', {
            subcat_image: values.subcat_image,
            cat_id: values.cat_id,
            subcat_name: values.subcat_name,
            description: values.description,
            subcat_code: values.subcat_code,
            display_status: values.display_status,
            cashback: `${values.cashback}`,
            discount_rate: `${values.discount_rate}`,
        }, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
            openNotificationWithIcon('success', res.data.message)
            window.location.reload()
        }).catch(err => {
            openNotificationWithIcon('error', err.response.data.message)
        })
    }

    const changeStatus = ({ id, value }) => {
        axios.patch(`/sub-category/display_status/${id}`, { status: value }, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
            openNotificationWithIcon('success', res.data.message)
            setUpdateCount(updateCount + 1)
        }).catch(err => {
            if (err.response) {
                if (err.response.data.message === "Unauthorized") {
                    windows.location.reload()
                    openNotificationWithIcon('error', err.response.data.message)
                } else {
                    openNotificationWithIcon('error', err.response.data.message)
                }
            } else {
                openNotificationWithIcon('error', err.message)
            }
        })
    }

    const uploadButton = (
        <div>
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div style={{ marginTop: 8 }}>Upload</div>

        </div>
    );
    const deleteCategory = (e) => {
        e.preventDefault();
        setIsModalVisible(true);
    }
    const handleOk = () => {
        setIsModalVisible(false);
    };
    const handleCancel = () => {
        setIsModalVisible(false);
    };
    const finaliseCategoryDelete = () => {
        setSpinnerLoading(true)
        axios.delete(`/sub-category/${selectedSubCategoryId}`, { headers: { Authorization: `Bearer ${token}` } })
            .then(res => {
                setSpinnerLoading(false);
                setIsModalVisible(false);
                openNotificationWithIcon('success', res.data.message);
                navigate()
            })
            .catch(err => {
                openNotificationWithIcon('error', err.response.data.message);
                setSpinnerLoading(false);
            });
    }

    const change_page = (selected_page, pageSize) => {
        setPage(selected_page);
        setPage_size(pageSize);
    }

    const getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.readAsDataURL(img);
        reader.addEventListener('load', () => callback(reader.result));
    }
    const selectSubImg = info => {
        getBase64(info.file.originFileObj, imageUrl =>
            setImageUrl(imageUrl),
            setLoading(false),
        );
        const reader = new FileReader();

        reader.readAsDataURL(info.file.originFileObj);
        reader.addEventListener('load', () => {
            setImageToSend(reader.result);
            form.setFieldsValue({ subcat_image: reader.result });
        });
    }


    let data = categoryBox.map((subcategory, index) => {
        return {
            key: index,
            id: subcategory.subCategoryData.id,
            name: subcategory.subCategoryData.subcat_name,
            subcat_code: subcategory.subCategoryData.subcat_code,
            totalProduct: subcategory.subCategoryData.total_product,
            discountRate: subcategory.subCategoryData.discount_rate,
            cashBack: subcategory.subCategoryData.cashback,
            displayStatus: <Form form={form} initialValues={{ display_status: subcategory.subCategoryData.display_status }}><Form.Item name="display_status" valuePropName="checked">{subcategory.subCategoryData.display_status ? <Button onClick={() => changeStatus({ value: false, id: subcategory.subCategoryData.id })}>Deactivate</Button> : <Button onClick={() => changeStatus({ value: true, id: subcategory.subCategoryData.id })}>Activate</Button>}</Form.Item></Form>,
            actions: <div><Link to={`/sub-categories/edit/${subcategory.subCategoryData.id}`}>Edit</Link> {deleteSubCategories && <> /<form className="inline-form"
                onSubmit={e => { deleteCategory(e); setSelectedSubCategoryId(subcategory.subCategoryData.id) }}>
                <input type="hidden" value={subcategory.subCategoryData.id} name="categoryId" />
                <Button type="link" htmlType="submit" className="inline-button">Delete</Button></form></>}</div>
        }
    });axios

    let categories = cat.map((cate, index) => {
        return {
            key: index,
            id: cate.cat.id,
            name: cate.cat.category_name
        }
    })
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
        },
        {
            title: 'Total Product',
            className: 'column-number',
            dataIndex: 'totalProduct',
            align: 'center',
        },
        {
            title: 'Sub-Category Code',
            className: 'column-number',
            dataIndex: 'subcat_code',
            align: 'center',
        },
        {
            title: 'Discount-Rate (%)',
            className: 'column-number',
            dataIndex: 'discountRate',
            align: 'center',
        },
        {
            title: 'Cash Back(%)',
            className: 'column-number',
            dataIndex: 'cashBack',
            align: 'center',
        },
        {
            title: 'Display-Status',
            className: 'column-number',
            dataIndex: 'displayStatus',
            align: 'center',
        },
        {
            title: 'Actions',
            className: 'column-number',
            dataIndex: 'actions',
            align: 'center',
        }
    ];
    const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info" >
                                <MDTypography variant="h6" color="white">
                                    SubCategories
                                </MDTypography>
                            </MDBox>
                            <MDBox py={3} px={2}>
                                {allProducts === 'sub-category' &&
                                    <Spin tip="Loading..." spinning={spinnerLoading}>
                                        <React.Fragment>
                                            <CCard>
                                                <CCardHeader>
                                                    <div className="grid-flex">
                                                        Sub-Categories List
                                                        <div>
                                                            {addSubCategories &&
                                                                <Button style={{ marginRight: '10px' }} type="primary" onClick={() => setAllProducts('add-sub-category')}>Add Sub-Category</Button>
                                                            }
                                                        </div>
                                                    </div>
                                                </CCardHeader>
                                                <CCardBody>
                                                    {
                                                        fetchingData ?
                                                            <div>
                                                                <Spin indicator={antIcon} />
                                                            </div> :
                                                            <div className="table-responsive">
                                                                <Table columns={columns} pagination={false} dataSource={data} bordered />
                                                                <div style={{ marginTop: "2%" }}></div>
                                                                <Pagination showSizeChanger current={page} total={total_subcategories} showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} subcategories`} defaultPageSize={page_size} onChange={change_page} />
                                                            </div>
                                                    }
                                                </CCardBody>
                                            </CCard>
                                        </React.Fragment>
                                        <Modal title="Delete Sub-Category" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} footer={null}>
                                            <p>Are you sure you want to delete this sub-category?</p>
                                            <div>
                                                <button onClick={() => setIsModalVisible(false)} style={{ border: '1px solid #F0F0F0', borderRadius: 4, padding: '10px 25px', background: 'transparent', marginRight: 10, fontSize: 12, fontWeight: '600' }}
                                                >Cancel</button>
                                                <button onClick={() => finaliseCategoryDelete()} style={{ border: '1px solid #FF4A00', borderRadius: 4, padding: '10px 25px', background: '#FF4A00', fontSize: 12, fontWeight: '600', color: '#fff' }}
                                                >Delete</button>
                                            </div>
                                        </Modal>
                                    </Spin>
                                }
                                {allProducts === 'add-sub-category' &&
                                    <React.Fragment>
                                        <CCard>
                                            <CCardHeader>
                                                <div className="grid-flex">
                                                    Add Sub-Category
                                                    <div>
                                                        <Button style={{ marginRight: '10px' }} type="primary" onClick={() => setAllProducts('sub-category')}>View Sub-Categories</Button>
                                                    </div>
                                                </div>
                                            </CCardHeader>
                                            <CCardBody>
                                                {
                                                    categoryErrorMessage ? <p className="error-message">{categoryErrorMessage}</p> : ''
                                                }
                                                <Form form={form} onFinish={addSubCategory} initialValues={{
                                                    display_status: false,
                                                    cashback: false
                                                }} layout="vertical">
                                                    <Form.Item name="subcat_image" label="Sub-Category Image" >
                                                        <Upload name="avatar" listType="picture-card" className="avatar-uploader" showUploadList={false} multiple={false} onChange={selectSubImg} >
                                                            {imageUrl ? <img src={imageUrl} alt="avatar" className="adminCourseUpload" /> : uploadButton}
                                                        </Upload>
                                                    </Form.Item>
                                                    <Form.Item name="cat_id" label="Choose Category" >
                                                        <Select>
                                                            {categories.map((title, index) => (
                                                                <Select.Option key={index} value={title.id}>{title.name}</Select.Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                    <Form.Item name="subcat_name" label="Sub-Category Name" >
                                                        <Input placeholder="Sub-Category Name" />
                                                    </Form.Item>
                                                    <Form.Item name="subcat_code" label="Category Code" >
                                                        <Input placeholder="Category Code" />
                                                    </Form.Item>
                                                    <Form.Item name="discount_rate" label="Discount Rate ( % )" >
                                                        <InputNumber style={{ width: "100%" }} min={0} max={100} placeholder="Discount Rate" />
                                                    </Form.Item>
                                                    <Form.Item name="cashback" label="Cashback ( % )" >
                                                        <InputNumber style={{ width: "100%" }} min={0} max={100} placeholder="Cashback" />
                                                    </Form.Item>
                                                    <Form.Item name="display_status" label="Display Status" >
                                                        <Select>
                                                            <Select.Option value={true}>Activate</Select.Option>
                                                            <Select.Option value={false}>De-activate</Select.Option>
                                                        </Select>
                                                    </Form.Item>
                                                    <Form.Item name="description" label="Sub-Category Description" >
                                                        <TextArea rows={4} placeholder="Category Description" />
                                                    </Form.Item>
                                                    <Form.Item>
                                                        <Button htmlType="submit" type="primary">Add Sub-category</Button>
                                                    </Form.Item>
                                                </Form>
                                            </CCardBody>
                                        </CCard>
                                    </React.Fragment>
                                }
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout >
    );

};

export default SubCategories;
